export default __webpack_public_path__ + "static/media/1182.12e17fa2.png";